import Nacimientos from "./Nacimientos";
export default Nacimientos;